import dynamic from "next/dynamic";

export const DynamicContent012 = dynamic(() => import("./Content012"), {
  suspense: true,
});
